











































import { Component, Mixins, Vue, Ref, Watch } from 'vue-property-decorator'
import SelectWithLabel, { SelectOption } from '@/components/common/molecules/SelectWithLabel.vue'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import StudySelectionApis, {
  StudyContentSelectType,
  StudyModesType,
  SubjectSelectType,
  SubjectDrillStatusType,
} from '@/mixins/requests/student/StudySelectionApis.vue'
import ModalStudySelection from '@/components/student/organisms/ModalStudySelection.vue'
import CookieMethods from '@/mixins/CookieMethods.vue'
import { StudyModeCodeType } from '@/constants/ApiConstant'

@Component({
  components: {
    SelectWithLabel,
    ButtonBase,
    ModalStudySelection,
  },
})
export default class StudySelection extends Mixins(StudySelectionApis, CookieMethods) {
  /** 学年選択 */
  private selectedGradeCode = ''
  private gradeOptions: SelectOption[] = []

  /** テストコンテンツ選択（ID） */
  private selectedStudyContentId = 0
  private studyContentOptions: SelectOption[] = []
  /** 選択テストコンテンツ：対象コンテンツの授業モード一覧 */
  private selectedStudyModes: StudyModesType[] = []
  /** 選択テストコンテンツ：授業モードコード */
  private selectedStudyModeCode: StudyModeCodeType = null

  /** 科目選択 */
  private selectedSubjectCode = ''
  private subjectOptions: SelectOption[] = []
  /** 選択科目：対象科目の進行中判定一覧 */
  private selectedSubjectDrillsStatus: SubjectDrillStatusType[] = []
  /** 選択科目：中断判定 */
  private selectedIsSuspended: SubjectDrillStatusType['isSuspended'] = null
  /** 選択科目：過去完了（受験済）判定 */
  private selectedIsCompleted: SubjectDrillStatusType['isCompleted'] = null
  /** 選択科目：利用可能レベル一覧 */
  private selectedAvailableStartLevels: SubjectDrillStatusType['availableStartLevels'] = []

  @Ref() modalStudySelection!: ModalStudySelection

  /**
   * 学年選択処理
   */
  @Watch('selectedGradeCode')
  private async onSelectedGrade(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      this.selectedStudyContentId = 0
      this.selectedSubjectCode = ''
      this.selectedStudyModeCode = null
      this.selectedIsSuspended = null
      this.selectedIsCompleted = null
      this.subjectOptions = []
      this.selectedSubjectDrillsStatus = []

      // 選択学年に紐付くテストコンテンツ取得
      const studyContentSelect: StudyContentSelectType = this.selectedGradeCode
        ? await this.loadStudyContents(this.selectedGradeCode, this.currentBranchId)
        : { options: [], studyModes: [] }
      this.studyContentOptions = studyContentSelect.options
      this.selectedStudyModes = studyContentSelect.studyModes
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  /**
   * テストコンテンツ選択処理
   */
  @Watch('selectedStudyContentId')
  private async onSelectedStudyContent(): Promise<void> {
    this.selectedSubjectCode = ''
    this.selectedIsSuspended = null
    this.selectedIsCompleted = null

    // 選択したテストコンテンツに紐付いた授業モードコード保持
    const selectedStudyMode = this.selectedStudyModes.find(
      (studyMode) => studyMode.studyContentId === Number(this.selectedStudyContentId)
    )
    this.selectedStudyModeCode = selectedStudyMode ? selectedStudyMode.studyModeCode : null
    Vue.prototype.$logger.log('studyModeCode', this.selectedStudyModeCode)

    // 選択したテストコンテンツに紐付く科目取得
    const subjectSelect: SubjectSelectType = this.selectedStudyContentId
      ? await this.loadSubjects(this.selectedStudyContentId)
      : { options: [], subjectDrillsStatus: [] }
    this.subjectOptions = subjectSelect.options
    this.selectedSubjectDrillsStatus = subjectSelect.subjectDrillsStatus
  }

  /**
   * 科目選択処理
   */
  @Watch('selectedSubjectCode')
  private async onSelectedSubject(): Promise<void> {
    // 選択した科目に紐付いた中断状態保持
    const selectedDrillStatus = this.selectedSubjectDrillsStatus.find(
      (resultDrill) => resultDrill.subjectCode === this.selectedSubjectCode
    )
    this.selectedIsSuspended = selectedDrillStatus ? selectedDrillStatus.isSuspended : null
    this.selectedIsCompleted = selectedDrillStatus ? selectedDrillStatus.isCompleted : null
    this.selectedAvailableStartLevels = selectedDrillStatus ? selectedDrillStatus.availableStartLevels : []
    Vue.prototype.$logger.log('isSuspended', this.selectedIsSuspended)
    Vue.prototype.$logger.log('isCompleted', this.selectedIsCompleted)
  }

  private async mounted(): Promise<void> {
    Vue.prototype.$loading.start()
    try {
      this.gradeOptions = await this.loadGrades()
    } finally {
      Vue.prototype.$loading.complete()
    }
  }

  private get isStartable(): boolean {
    return !!(this.selectedGradeCode && this.selectedStudyContentId && this.selectedSubjectCode)
  }

  /**
   * ドリル開始時のレベル選択が不要な状態か判定
   */
  private get isAutoLevelSelection(): boolean {
    return !!(this.selectedIsSuspended || this.selectedIsCompleted)
  }

  // ドリル開始
  private async startDrill(startLevel: number | null): Promise<void> {
    Vue.prototype.$logger.log('startLevel', startLevel)

    if (document.body.clientWidth <= 768) {
      return alert('タブレットを使（つか）うときは、横（よこ）にしてください。')
    }

    let resultDrillId
    try {
      // ドリル開始リクエスト
      const res = await this.studyStartApi(
        this.selectedGradeCode,
        this.selectedSubjectCode,
        this.selectedStudyContentId,
        startLevel
      )
      resultDrillId = res.resultDrillId
    } catch (e: any) {
      Vue.prototype.$logger.error(e)
      if (e.response.data.status == 400) {
        return alert(e.response.data.message)
      } else {
        return alert('受験可能期間を過ぎています。')
      }
    }

    this.$router.push({ name: 'StudentStudy', query: { resultDrillId: resultDrillId.toString() } })
  }

  private showResult(): void {
    this.$router.push({ name: 'StudentStudyResult' })
  }

  private showStudySelectionModal(): void {
    this.modalStudySelection.show()
  }
}
